import { Box, TextField, Typography } from "@mui/material"
import { type FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import type { ProductInfoFormValues } from "./productFormSchema"
import ProductShipLocationSelect from "./ProductShipLocationSelect"

import { FIELD_ERROR_CLASSES, FIELD_LABEL_CLASSES, TEXT_FIELD_STYLING_PROPS } from "@/constants/forms"

interface FormFieldProps {
  name: keyof ProductInfoFormValues
  label: string
  placeholder: string
  required?: boolean
}

const FormTextField: FC<FormFieldProps> = ({ name, label, placeholder, required }) => {
  const { control } = useFormContext<ProductInfoFormValues>()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Box className='mt-6'>
          <label className={FIELD_LABEL_CLASSES}>
            {label}
            {required && <span className='text-red-600'>*</span>}
          </label>
          <TextField {...field} {...TEXT_FIELD_STYLING_PROPS} error={!!error} placeholder={placeholder} />
          {error?.message && <p className={FIELD_ERROR_CLASSES}>{error.message}</p>}
        </Box>
      )}
    />
  )
}

export const ProductInfoForm: FC = () => {
  const { control } = useFormContext<ProductInfoFormValues>()

  return (
    <form>
      <Typography variant='body1' fontWeight={700} className='leading-6 tracking-[0.15px] text-gray-700'>
        1. Product information
      </Typography>
      <Box className='space-y-10'>
        <FormTextField name='vendorSku' label='Vendor Product SKU' placeholder='Add SKU' />
        <FormTextField
          name='vendorDescription'
          label='Vendor Description'
          placeholder='Add Vendor Product Description'
          required
        />
        <FormTextField
          name='companyProductDescription'
          label='Akrochem Description'
          placeholder='Add Akrochem Product Description'
          required
        />
        <Controller
          name='locationsAssociations'
          control={control}
          render={() => <ProductShipLocationSelect name='locationsAssociations' control={control} />}
        />
      </Box>
    </form>
  )
}
